import React from 'react';
import PropTypes from 'prop-types';

export const icons = {
    Биатлон: 'icon-biatlon',
    Бобслей: 'icon-bobslej',
    'Горнолыжный спорт': 'icon-lyzhy',
    Кёрлинг: 'icon-kerling',
    'Конькобежный спорт': 'icon-konky',
    'Лыжные гонки': 'icon-lyzhnaya-gonka',
    'Лыжное двоеборье': 'icon-dveobore',
    'Прыжки с трамплина': 'icon-tramplin',
    'Санный спорт': 'icon-sannyj-sport',
    Скелетон: 'icon-skeleton',
    Сноуборд: 'icon-snoubord',
    'Фигурное катание': 'icon-figurnoe',
    Фристайл: 'icon-fristajl',
    Хоккей: 'icon-hokkej',
    'Шорт-трек': 'icon-shorttrek'
};

const SvgIcon = props => (
    <svg className={`icon ${icons[props.typeID]}`}>
        <use xlinkHref={`#${icons[props.typeID]}`} />
    </svg>
);

SvgIcon.propTypes = {
    typeID: PropTypes.string.isRequired
};

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/components/SvgIcon.jsx